
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button, Form, Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { API_URL } from '../config';

const ResetPasswordPage = () => {
  const [users, setUsers] = useState([]); // List of users to select from
  const [selectedUserId, setSelectedUserId] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch users when the component loads
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${API_URL}/users`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        setUsers(response.data);
      } catch (error) {
        console.error('Error fetching users:', error);
        if (error.response?.status === 401) {
          toast.error('Your session expired. Please log in again.');
          navigate('/login');
        }
      }
    };

    fetchUsers();
  }, []);

  const handlePasswordReset = async () => {
    if (newPassword !== confirmPassword) {
      toast.error("Passwords don't match");
      return;
    }

    try {
      // Send reset password request to the backend
      await axios.post(
        `${API_URL}/users/reset-password`,
        {
          userId: selectedUserId,
          newPassword: newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      toast.success('Password reset successful');
      navigate('/superuser-dashboard'); // Redirect to dashboard after successful reset
    } catch (error) {
      console.error('Error resetting password:', error);
      toast.error('Failed to reset password');
    }
  };

  return (
    <div className="container p-4">
      <h2>Reset User Password</h2>
      <Form>
        <Row>
          <Col md={6}>
            <Form.Group controlId="userSelect">
              <Form.Label>Select User</Form.Label>
              <Form.Control
                as="select"
                value={selectedUserId}
                onChange={(e) => setSelectedUserId(e.target.value)}
              >
                <option value="">Select a user</option>
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.first_name} {user.last_name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group controlId="newPassword">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="confirmPassword">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="mt-3 d-flex gap-2">
            <Button variant="primary" onClick={handlePasswordReset}>
                Reset Password
            </Button>
            <Button
                variant="secondary"
                onClick={() => navigate('/superuser-dashboard')}
            >
                Cancel / Back to Dashboard
            </Button>
        </div>


        
      </Form>
    </div>
  );
};

export default ResetPasswordPage;
